export const BIO = [
  "I'm a frontend-focused engineer based in Cairo, working remotely with teams across the globe to plan, build, and improve great user experiences.",
  'I thrive on turning ideas into intuitive, delightful interfaces, collaborating closely with design and product from the earliest stages.',
  'I care deeply about architecture and performance, but polish is never an afterthought. I like interfaces that feel clean, intentional, and exactly right.',
];

export const LANGUAGES = [
  { name: 'English', level: 'Bilingual' },
  { name: 'Arabic', level: 'Native' },
];
